import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { useLocation, useLink } from '@grandvisionhq/frk-routing';
import { useApolloClient } from '@grandvisionhq/graphql';
import { usePaymentsUIContext } from '@grandvisionhq/payments';
import '@grandvisionhq/utils';
import '@grandvisionhq/api-client';
import { dispatchCartChangeEvent } from '../../hooks/carts/use-cart-change-listener.js';
import '@grandvisionhq/state';
import '../../StepShipping/selectors.js';
import 'lodash/isEmpty';
import '../../mappers/errors-mapping.js';
import '../../utils/get-customer-details-payload.js';
import { getUpdatedUrlWithQueryParams, appendQueryParamToUrl } from '../../utils/get-updated-url-with-query-params.js';
import '../../models/cart/cart-state.js';
import '../../models/checkout/checkout-step-error-type.js';
import '../../models/checkout-settings.js';
import '../../models/step-shipping/shipping-methods.js';
import '../../models/shared.js';
import 'history';
import '../../utils/has-cart-errors.js';
import '@grandvisionhq/auth';
import '../../context/CheckoutSettings/context.js';
import '../../selectors.js';
import '@grandvisionhq/common';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-tealium/events';
import '../../operations/mutations/set-customer-details.js';
import '../../operations/mutations/set-service-store.js';
import '../../operations/mutations/set-shipping-method.js';
import '../../operations/mutations/set-shipping-state.js';
import '../../operations/mutations/set-store.js';
import '../../operations/mutations/create-apple-pay-session.js';
import '../../operations/mutations/recreate-ordered-checkout.js';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../../operations/fragments/checkout-mutation-result.js';
import '../../operations/fragments/cart-mutation-failures.js';
import '../../operations/fragments/recreate-ordered-checkout-failure.js';
import '../../operations/fragments/recreate-ordered-checkout-result.js';
import '../../operations/fragments/paypal-payment.js';
import '../../operations/fragments/saved-user-details.js';
import '../../operations/queries/get-checkout-state.js';
import '../../operations/queries/get-user-details.js';
import { recoverCheckout } from '../../pages/api/recover-checkout.js';

const useHandleQrFormUpdates = ({ qrPaymentConfig , selfUrl , paymentMethodType , paymentMethodLogos , orderDataToken , orderId , paymentFlow ,  })=>{
    const { cart , fetchByCartId  } = Context.useCart();
    const { paymentQRCodeState  } = usePaymentsUIContext();
    const apolloClient = useApolloClient();
    const { push  } = useLocation();
    const { href: orderConfirmHref  } = useLink({
        route: 'order.confirm',
        params: {
            orderData: ''
        }
    }) || {};
    /**
   *  Reload payment page url with new cartId
   *
   */ const updatedUrl = React.useCallback((cartId, cartHash)=>{
        const redirectUrl = getUpdatedUrlWithQueryParams(swcHelpers.objectSpread({
            cartId
        }, cartHash ? {
            cartHash
        } : {}, {
            type: paymentMethodType
        }));
        push(redirectUrl);
    }, [
        paymentMethodType,
        push
    ]);
    const replicateCart = React.useCallback((oldCartId)=>{
        return recoverCheckout(apolloClient, oldCartId);
    }, [
        apolloClient
    ]);
    const refetch = React.useCallback((cartId, cartHash)=>{
        fetchByCartId(cartId, cartHash);
        dispatchCartChangeEvent(cartId);
        updatedUrl(cartId, cartHash);
    }, [
        fetchByCartId,
        updatedUrl
    ]);
    /*
   *  Listen for QR code payment status
   *  if paymentState is 'Paid' then redirect to order confirm page
   */ React.useEffect(()=>{
        if (paymentQRCodeState === 'Paid' && orderConfirmHref && orderDataToken) {
            push(appendQueryParamToUrl(orderConfirmHref, {
                cartId: cart === null || cart === void 0 ? void 0 : cart.id,
                orderData: orderDataToken
            }));
        }
    }, [
        cart === null || cart === void 0 ? void 0 : cart.id,
        paymentQRCodeState,
        orderConfirmHref,
        push,
        orderDataToken
    ]);
    /**
   * @description
   * QrCodeFormData for the new paymentMethodsUI
   */ const qrCodeFormData = React.useMemo(()=>{
        var ref;
        return {
            paymentMethodType,
            selfUrl,
            logoUrl: paymentMethodLogos && ((ref = paymentMethodLogos[paymentMethodType]) === null || ref === void 0 ? void 0 : ref.url),
            orderId,
            qrPaymentConfig,
            orderToken: orderDataToken,
            refetch,
            paymentFlow,
            getNewCart: replicateCart
        };
    }, [
        paymentMethodType,
        selfUrl,
        paymentMethodLogos,
        orderId,
        qrPaymentConfig,
        orderDataToken,
        refetch,
        paymentFlow,
        replicateCart, 
    ]);
    return [
        qrCodeFormData
    ];
};

export { useHandleQrFormUpdates };
//# sourceMappingURL=use-handle-qr-form-updates.js.map
